import React, { Component } from "react";
import { connect } from "react-redux";
import { addSettings } from "../../../actions";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitleBreadCrumb from "../ExtraComponents/PageTitleBreadCrumb";
import HelperClass from "./../../../config/helperClass";
import localization from "../../../localization/enUS";
import Tooltip from "@material-ui/core/Tooltip";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { ValidateEmail } from "../../../config/utility";
import {
  listPartnerSubAgents,
  sendPartnerSubAgentInvite,
  getPartnerSubAgentInvites,
  deletePartnerSubAgentInvite,
  getAgentLogin,
} from "./../../../config/api_calls";

const auth = new HelperClass();

// PARTNER SUB-AGENTS: full agent accounts owned by this Main Agent
// (users.main_agent_accountno on the channel portal). A different concept
// from Sub Users (shared staff logins) — see /agents/subagents for those.
class PartnerSubagents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      tableLoader: true,
      tableDataInvites: [],
      tableLoaderInvite: true,
      activeTabCP: "tabItem7",
      agent_id: "",
      disabled: false,
      // Invite form (field names mirror the Sub User invite modal)
      agent_name: "",
      agent_email: "",
      invitation_comment: "",
      errorMessageInvite: "",
      successMessageInvite: "",
      // Delete invitation
      delete_invitation_id: "",
      errorMessageDelete: "",
      successMessageDelete: "",
      deleteInviteLoading: false,
      // Per-row resend loading (holds the invitation id being resent)
      resendingInviteId: "",
      // Login-to-dashboard modal
      showLoginModal: false,
      loginErrorMessage: "",
      login_url: "",

      columnServices: [
        { name: "Date Added" },
        { name: "Company" },
        { name: "Name" },
        { name: "Email" },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "ID",
          options: { display: false },
        },
        { name: "Account #" },
        { name: "Commission %" },
        {
          // What the Main keeps on THIS Sub Agent's orders. Blank when the
          // Main's commission is not a percentage of the order total.
          name: "Main Keeps %",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value && value !== "" ? value + "%" : "---"}</div>;
            },
            filter: false,
          },
        },
        {
          name: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minHeight: 36,
                  }}
                >
                  <Tooltip title="View Sub Agent details" placement="top">
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.addMenuHistory(
                          "/viewAgent/" +
                            tableMeta.rowData[6] +
                            "?type=sub_agent",
                        )
                      }
                    >
                      <em
                        className="icon ni ni-setting text-info"
                        style={{ fontSize: 20 }}
                      />
                    </a>
                  </Tooltip>
                  <Tooltip title="Login to the Sub Agent" placement="top">
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => this.agentLogin(tableMeta)}
                    >
                      <em
                        className="icon ni ni-signin text-primary"
                        style={{
                          fontSize: 20,
                          paddingLeft: 5,
                          borderLeft: "1px solid rgb(0 0 0 / 87%)",
                        }}
                      />
                    </a>
                  </Tooltip>
                </div>
              );
            },
          },
        },
      ],
      columnInvites: [
        { name: `Sub Agent Name` },
        { name: `Sub Agent Email` },
        { name: "Invited On" },
        {
          name: "ID",
          options: { display: false },
        },
        { name: "Comment" },
        {
          name: "Link",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <Tooltip title="Copy invitation link" placement="top">
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => this.copyInviteLink(value)}
                  >
                    <em className="icon ni ni-copy"></em> Copy
                  </a>
                </Tooltip>
              );
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div
                  className="nk-tb-col nk-tb-col-tools"
                  style={{ padding: "0px" }}
                >
                  <ul className="nk-tb-actions gx-1">
                    <li>
                      <Tooltip title="Resend Invite" placement="top">
                        <a
                          style={{
                            cursor:
                              this.state.resendingInviteId !== ""
                                ? "not-allowed"
                                : "pointer",
                            pointerEvents:
                              this.state.resendingInviteId !== ""
                                ? "none"
                                : "auto",
                          }}
                          onClick={() => this.resendInvite(tableMeta)}
                          className="btn btn-icon btn-outline-light"
                        >
                          {this.state.resendingInviteId ===
                          tableMeta.rowData[3] ? (
                            <em className="icon ni ni-loader"></em>
                          ) : (
                            <em className="icon ni ni-send"></em>
                          )}
                        </a>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip title="Delete Invite" placement="top">
                        <a
                          style={{
                            cursor:
                              this.state.resendingInviteId !== ""
                                ? "not-allowed"
                                : "pointer",
                            pointerEvents:
                              this.state.resendingInviteId !== ""
                                ? "none"
                                : "auto",
                          }}
                          onClick={() =>
                            this.openDeleteInviteModal(tableMeta.rowData[3])
                          }
                          className="btn btn-icon btn-outline-light"
                        >
                          <em className="icon ni ni-trash"></em>
                        </a>
                      </Tooltip>
                    </li>
                  </ul>
                </div>
              );
            },
          },
        },
      ],
    };
  }

  async componentDidMount() {
    let agent_id = this.props.props.match.params.id;
    this.setState({ agent_id: agent_id });
    await this.loadSubAgents(agent_id);
    await this.loadInvites(agent_id);
  }

  // Normalizes a row array so null/undefined cells render as empty strings
  // instead of breaking custom renderers.
  cleanRows = (rows) => {
    if (!rows || !Array.isArray(rows)) return [];
    return rows.map((row) =>
      Array.isArray(row)
        ? row.map((cell) => (cell === null || cell === undefined ? "" : cell))
        : row,
    );
  };

  loadSubAgents = async (agent_id) => {
    try {
      const listResponse = await listPartnerSubAgents(
        auth.getAccount(),
        auth.getToken(),
        Number(agent_id),
      );
      if (
        listResponse &&
        listResponse.data &&
        (listResponse.data.status === 403 ||
          listResponse.data.errors === "authentication missing" ||
          listResponse.data.errors === "jwt expired")
      ) {
        auth.logout();
      } else if (
        listResponse &&
        listResponse.data &&
        listResponse.data.status === 200 &&
        listResponse.data.message === "success"
      ) {
        this.setState({
          tableData: this.cleanRows(listResponse.data.data),
          tableLoader: false,
        });
      } else {
        // not_found / api failure -> empty table renders the standard
        // "no matching records" state.
        this.setState({ tableData: [], tableLoader: false });
      }
    } catch (error) {
      console.log("loadSubAgents catch: ", error);
      this.setState({ tableData: [], tableLoader: false });
    }
  };

  loadInvites = async (agent_id) => {
    try {
      const inviteResponse = await getPartnerSubAgentInvites(
        auth.getAccount(),
        auth.getToken(),
        Number(agent_id),
      );
      if (
        inviteResponse &&
        inviteResponse.data &&
        (inviteResponse.data.status === 403 ||
          inviteResponse.data.errors === "authentication missing" ||
          inviteResponse.data.errors === "jwt expired")
      ) {
        auth.logout();
      } else if (
        inviteResponse &&
        inviteResponse.data &&
        inviteResponse.data.status === 200 &&
        inviteResponse.data.message === "success"
      ) {
        this.setState({
          tableDataInvites: this.cleanRows(inviteResponse.data.data),
          tableLoaderInvite: false,
        });
      } else {
        this.setState({ tableDataInvites: [], tableLoaderInvite: false });
      }
    } catch (error) {
      console.log("loadInvites catch: ", error);
      this.setState({ tableDataInvites: [], tableLoaderInvite: false });
    }
  };

  setStatus = (value, tableMeta) => {
    if (value === "inactive") {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-signin"></em> Inactive
        </span>
      );
    } else if (value === "active") {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    }
    return <span className="badge badge-outline-light">{value}</span>;
  };

  handleTabClick = (tabId) => {
    this.setState({ activeTabCP: tabId });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  // Same flow as the Partners listing: opens the connecting modal, fetches
  // the SSO login URL for the (full agent) Sub-Agent account, then opens the
  // agent portal dashboard in a new tab.
  agentLogin = async (tableMeta) => {
    const agent_id = tableMeta.rowData[5];
    this.setState({
      loginErrorMessage: "",
      login_url: "",
      showLoginModal: true,
    });
    try {
      const servicesResponce = await getAgentLogin(
        auth.getAccount(),
        auth.getToken(),
        agent_id,
      );
      if (
        servicesResponce &&
        servicesResponce.data &&
        (servicesResponce.data.status === 403 ||
          servicesResponce.data.errors === "authentication missing" ||
          servicesResponce.data.errors === "jwt expired")
      ) {
        auth.logout();
      } else if (
        servicesResponce &&
        servicesResponce.data &&
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "inactive"
      ) {
        this.setState({ loginErrorMessage: "Account is not active." });
      } else if (
        servicesResponce &&
        servicesResponce.data &&
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "notVerified"
      ) {
        this.setState({
          loginErrorMessage:
            "Account is not verified. Please check your email and click verify link.",
        });
      } else if (
        servicesResponce &&
        servicesResponce.data &&
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({ login_url: servicesResponce.data.login_url });
        this.closeLoginModal();
        setTimeout(() => {
          window.open(servicesResponce.data.login_url, "_blank");
        }, 500);
      } else {
        this.setState({
          loginErrorMessage:
            "There is some error while authenticating the account.",
        });
      }
    } catch (error) {
      console.log("agentLogin catch: ", error);
      this.setState({
        loginErrorMessage:
          "There is some error while authenticating the account.",
      });
    }
  };

  closeLoginModal = () => {
    this.setState({
      showLoginModal: false,
      loginErrorMessage: "",
      login_url: "",
    });
  };

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    this.setState({ [name]: value });
  };

  setNewAgentSettings = () => {
    this.setState({
      agent_name: "",
      agent_email: "",
      invitation_comment: "",
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: false,
    });
    window.$("#modalInvitePartnerSubAgent").modal("show");
  };

  saveNewAgent = async () => {
    const { agent_name, agent_email, invitation_comment } = this.state;
    if (agent_name === "") {
      return this.setState({
        errorMessageInvite: "Please enter the name.",
        successMessageInvite: "",
      });
    }
    if (agent_email === "") {
      return this.setState({
        errorMessageInvite: "Please enter the email address.",
        successMessageInvite: "",
      });
    }
    if (ValidateEmail(agent_email) === false) {
      return this.setState({
        errorMessageInvite: "Please enter the valid email address.",
        successMessageInvite: "",
      });
    }
    if (invitation_comment === "") {
      return this.setState({
        errorMessageInvite: "Please enter the comment.",
        successMessageInvite: "",
      });
    }
    this.setState({ disabled: true, errorMessageInvite: "" });
    try {
      const inviteResponse = await sendPartnerSubAgentInvite(
        auth.getAccount(),
        auth.getToken(),
        Number(this.state.agent_id),
        agent_name,
        agent_email,
        invitation_comment,
      );
      if (
        inviteResponse &&
        inviteResponse.data &&
        (inviteResponse.data.status === 403 ||
          inviteResponse.data.errors === "authentication missing" ||
          inviteResponse.data.errors === "jwt expired")
      ) {
        auth.logout();
      } else if (
        inviteResponse &&
        inviteResponse.data &&
        inviteResponse.data.status === 200 &&
        inviteResponse.data.message === "success"
      ) {
        this.setState({
          successMessageInvite:
            "Invitation has been sent to the provided email address.",
          errorMessageInvite: "",
          disabled: false,
        });
        await this.loadInvites(this.state.agent_id);
        setTimeout(() => {
          window.$("#modalInvitePartnerSubAgent").modal("hide");
        }, 2000);
      } else if (
        inviteResponse &&
        inviteResponse.data &&
        inviteResponse.data.message === "Account Already Exists"
      ) {
        this.setState({
          errorMessageInvite:
            "An account with this email address already exists.",
          successMessageInvite: "",
          disabled: false,
        });
      } else if (
        inviteResponse &&
        inviteResponse.data &&
        inviteResponse.data.message === "target_not_main_agent"
      ) {
        this.setState({
          errorMessageInvite:
            "Sub Agents can only be created for a Main Agent account.",
          successMessageInvite: "",
          disabled: false,
        });
      } else {
        this.setState({
          errorMessageInvite: "Something went wrong, try again later.",
          successMessageInvite: "",
          disabled: false,
        });
      }
    } catch (error) {
      console.log("saveNewAgent catch: ", error);
      this.setState({
        errorMessageInvite: "Something went wrong, try again later.",
        successMessageInvite: "",
        disabled: false,
      });
    }
  };

  resendInvite = async (tableMeta) => {
    const invite_name = tableMeta.rowData[0];
    const invite_email = tableMeta.rowData[1];
    const invitation_comment = tableMeta.rowData[4] || "";
    this.setState({ resendingInviteId: tableMeta.rowData[3] });
    try {
      const inviteResponse = await sendPartnerSubAgentInvite(
        auth.getAccount(),
        auth.getToken(),
        Number(this.state.agent_id),
        invite_name,
        invite_email,
        invitation_comment,
      );
      if (
        inviteResponse &&
        inviteResponse.data &&
        inviteResponse.data.status === 200 &&
        inviteResponse.data.message === "success"
      ) {
        window
          .$("#modalAlertPartnerSubAgent .modal-body-text")
          .text("Invitation resent successfully to " + invite_email + ".");
      } else {
        window
          .$("#modalAlertPartnerSubAgent .modal-body-text")
          .text("Unable to resend the invitation. Please try again later.");
      }
    } catch (error) {
      window
        .$("#modalAlertPartnerSubAgent .modal-body-text")
        .text("Unable to resend the invitation. Please try again later.");
    }
    this.setState({ resendingInviteId: "" });
    window.$("#modalAlertPartnerSubAgent").modal("show");
    await this.loadInvites(this.state.agent_id);
  };

  copyInviteLink = (link) => {
    if (link && navigator.clipboard) {
      navigator.clipboard.writeText(link);
      window
        .$("#modalAlertPartnerSubAgent .modal-body-text")
        .text("Invitation link copied to clipboard.");
      window.$("#modalAlertPartnerSubAgent").modal("show");
    }
  };

  openDeleteInviteModal = (invitation_id) => {
    this.setState({
      delete_invitation_id: invitation_id,
      errorMessageDelete: "",
      successMessageDelete: "",
    });
    window.$("#modalDeletePartnerSubAgentInvite").modal("show");
  };

  submitDeleteInvite = async () => {
    this.setState({ deleteInviteLoading: true });
    try {
      const deleteResponse = await deletePartnerSubAgentInvite(
        auth.getAccount(),
        auth.getToken(),
        Number(this.state.agent_id),
        this.state.delete_invitation_id,
      );
      if (
        deleteResponse &&
        deleteResponse.data &&
        (deleteResponse.data.status === 403 ||
          deleteResponse.data.errors === "authentication missing" ||
          deleteResponse.data.errors === "jwt expired")
      ) {
        auth.logout();
      } else if (
        deleteResponse &&
        deleteResponse.data &&
        deleteResponse.data.status === 200 &&
        deleteResponse.data.message === "success"
      ) {
        this.setState({
          successMessageDelete: "Invitation deleted successfully.",
          errorMessageDelete: "",
          deleteInviteLoading: false,
        });
        await this.loadInvites(this.state.agent_id);
        setTimeout(() => {
          window.$("#modalDeletePartnerSubAgentInvite").modal("hide");
        }, 2000);
      } else {
        this.setState({
          errorMessageDelete: "Unable to delete the invitation.",
          successMessageDelete: "",
          deleteInviteLoading: false,
        });
      }
    } catch (error) {
      console.log("submitDeleteInvite catch: ", error);
      this.setState({
        errorMessageDelete: "Unable to delete the invitation.",
        successMessageDelete: "",
        deleteInviteLoading: false,
      });
    }
  };

  render() {
    const breadcrumb_arr = [
      {
        title: localization.specificPortals.agentsLabel,
        url: "/agents",
      },
      {
        title: "Sub Agents",
        url: "",
      },
    ];
    return (
      <div className="nk-content " id="PartnerSubAgents_Block">
        <div className="container-fluid">
          {/* MSA WARNING START */}
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitleBreadCrumb
                        name={breadcrumb_arr}
                        icon="icon ni ni-user-list"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <a
                              onClick={() => this.setNewAgentSettings()}
                              className="btn btn-primary"
                              style={{ color: "white", cursor: "pointer" }}
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp;Invite New Sub Agent
                            </a>
                          </li>
                          <li className="nk-block-tools-opt">
                            <a
                              href={`/agents/Addpartnersubagent/${this.state.agent_id}`}
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp;Add New Sub Agent
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}

              <div className="nk-block">
                <div className="row g-gs">
                  <div className="col-xxl-12">
                    <div className="row g-gs" style={{ clear: "both" }}>
                      <div className="col-lg-12">
                        <div
                          className="card card-bordered"
                          style={{ clear: "both" }}
                        >
                          <div className="card-inner">
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.activeTabCP === "tabItem7"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#tabItem7"
                                  onClick={() =>
                                    this.handleTabClick("tabItem7")
                                  }
                                >
                                  <em className="icon ni ni-user-list"></em>
                                  <span>All Sub Agents</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.activeTabCP === "tabItem8"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#tabItem8"
                                  onClick={() =>
                                    this.handleTabClick("tabItem8")
                                  }
                                >
                                  <em className="icon ni ni-mail"></em>
                                  <span>Pending Invitations</span>
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className={`tab-pane ${
                                  this.state.activeTabCP === "tabItem7"
                                    ? "active"
                                    : ""
                                }`}
                                id="tabItem7"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.columnServices}
                                    tableData={this.state.tableData}
                                    title="All Sub Agents"
                                  />
                                )}
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.activeTabCP === "tabItem8"
                                    ? "active"
                                    : ""
                                }`}
                                id="tabItem8"
                              >
                                {this.state.tableLoaderInvite === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.columnInvites}
                                    tableData={this.state.tableDataInvites}
                                    title="Pending Invitations"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Invite New Sub Agent Modal Start (mirrors the Sub User
                  invite modal in subagent.js for portal consistency) */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalInvitePartnerSubAgent"
              >
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em
                          className="icon ni ni-user-add"
                          style={{ marginRight: "8px" }}
                        ></em>{" "}
                        Invite New Sub Agent
                      </h5>
                    </div>
                    <div className="modal-body">
                      <div className="row g-4">
                        {this.state.errorMessageInvite !== "" ? (
                          <div className="col-md-12 mb-3">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageInvite}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageInvite !== "" ? (
                          <div className="col-md-12 mb-3">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageInvite}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="col-md-6">
                          <div className="form-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="agent_name"
                                name="agent_name"
                                type="text"
                                label="Full Name"
                                defaultValue={this.state.agent_name}
                                inputProps={{ maxLength: 64 }}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^a-zA-Z\s'.,:\-()|!@]/gi,
                                    "",
                                  );
                                }}
                                helperText="Full name of the invite recipient."
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="agent_email"
                                name="agent_email"
                                type="text"
                                label="Email Address"
                                defaultValue={this.state.agent_email}
                                helperText="Email address of the invite recipient."
                                inputProps={{ maxLength: 100 }}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                autoComplete="new-password"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="form-control-group">
                              <TextareaAutosize
                                maxrows={4}
                                name="invitation_comment"
                                id="invitation_comment"
                                aria-label=""
                                placeholder="Add Comment *"
                                value={this.state.invitation_comment}
                                onChange={this.handleChange}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  borderColor: "rgba(0, 0, 0, 0.125)",
                                  borderRadius: "4px",
                                  padding: "5px",
                                }}
                                variant="outlined"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            type="button"
                            onClick={() => this.saveNewAgent()}
                            className="btn btn-primary"
                            disabled={this.state.disabled}
                          >
                            {this.state.disabled ? (
                              <>
                                <em className="icon ni ni-loader"></em>
                                &nbsp;<span>Sending...</span>
                              </>
                            ) : (
                              <>
                                <span>Send Invite</span>{" "}
                                <em className="icon ni ni-emails"></em>
                              </>
                            )}
                          </button>
                        </div>
                        <div className="col-md-12">
                          <div className="example-alert">
                            <div className="alert alert-light">
                              <ul className="list">
                                <li>
                                  An email will be dispatched to the provided
                                  email address.
                                </li>
                                <li>
                                  This email will contain a secure, tokenized
                                  link for sub agent registration.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Invite New Sub Agent Modal End */}

              {/* DELETE INVITE MODAL START */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalDeletePartnerSubAgentInvite"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>
                        <h4 className="nk-modal-title">Delete Invitation?</h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessageDelete !== "" ? (
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <p>{this.state.errorMessageDelete}</p>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageDelete !== "" ? (
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <p>{this.state.successMessageDelete}</p>
                              </div>
                            </div>
                          ) : null}
                          <p>
                            This will cancel the pending Sub Agent invitation.
                            The invitation link will no longer be listed here.
                          </p>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-light"
                            data-dismiss="modal"
                          >
                            Cancel
                          </a>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => this.submitDeleteInvite()}
                            disabled={this.state.deleteInviteLoading}
                          >
                            {this.state.deleteInviteLoading ? (
                              <>
                                <em className="icon ni ni-loader"></em>
                                &nbsp;Deleting...
                              </>
                            ) : (
                              "Delete"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* DELETE INVITE MODAL END */}

              {/* LOGIN-TO-DASHBOARD MODAL START (same flow as the Partners
                  listing: connecting state, then a new tab opens) */}
              {this.state.showLoginModal && (
                <div
                  className="modal fade show"
                  tabIndex="-1"
                  id="modalPartnerSubAgentLogin"
                  style={{ display: "block" }}
                  role="dialog"
                >
                  <div
                    className="modal-dialog modal-dialog-top modal-xl"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        onClick={() => this.closeLoginModal()}
                        className="close"
                        style={{ cursor: "pointer" }}
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <em
                            className="icon ni ni-user-list"
                            style={{ marginRight: "15px" }}
                          ></em>
                          Login to the Sub Agent
                        </h5>
                      </div>
                      <div className="modal-body">
                        {this.state.loginErrorMessage === "" ? (
                          <div className="alert alert-pro alert-primary">
                            <div className="alert-text">
                              <h6>Connecting.....</h6>
                              <p>
                                Please wait while we are connecting to the Sub
                                Agent login. You will be redirected to the
                                dashboard after the authentication.
                              </p>
                            </div>
                          </div>
                        ) : null}
                        {this.state.loginErrorMessage !== "" ? (
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h6>Login Error</h6>
                              <p>{this.state.loginErrorMessage}</p>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.showLoginModal && (
                <div className="modal-backdrop fade show"></div>
              )}
              {/* LOGIN-TO-DASHBOARD MODAL END */}

              {/* GENERIC ALERT MODAL START */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalAlertPartnerSubAgent"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-info bg-primary"></em>
                        <h4 className="nk-modal-title">Sub Agents</h4>
                        <div className="nk-modal-text">
                          <p className="modal-body-text"></p>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-primary"
                            data-dismiss="modal"
                          >
                            OK
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* GENERIC ALERT MODAL END */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PartnerSubagents);
